module.exports = __webpack_public_path__ + "static/media/preanestesas2-nav.1f151d11.png";